// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var ConnnectionResponseCode;
(function (ConnnectionResponseCode) {
    /// <summary>
    /// https://tp.traderevolution.com/entity/122218
    /// </summary>
    ConnnectionResponseCode[ConnnectionResponseCode["SAFE_DISCONECT"] = 12] = "SAFE_DISCONECT";
})(ConnnectionResponseCode || (ConnnectionResponseCode = {}));
